<template>
  <TransactionModal />
  <ClientModal />
  <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
    <transition-group name="slide-fade">
      <div v-for="alert in alerts" :key="alert.id" class="toast show align-items-center border-0 shadow-lg mb-2"
        :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
        <div class="d-flex p-3">
          <i :class="alert.icon" class="me-3 fs-5"></i>
          <div class="toast-body p-0 fw-medium">
            {{ alert.message }}
          </div>
          <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
        </div>
      </div>
    </transition-group>
  </div>
  <nav class="navbar navbar-expand-lg navbar-pmg bg-white shadow-sm sticky-top">
    <div class="container-fluid px-3 px-lg-4">

      <router-link to="/" class="navbar-brand d-flex align-items-center">
        <LogoSystem height="150px" style="transform: scale(0.8); margin-top: -30px; margin-bottom: -30px;" />
      </router-link>

      <button class="navbar-toggler border-0 shadow-none p-2" type="button" data-bs-toggle="collapse"
        data-bs-target="#mainNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="mainNavbar">

        <ul class="navbar-nav me-auto mb-2 mb-lg-0 d-none d-lg-flex">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle d-flex align-items-center gap-2 fw-bold text-dark px-3" href="#"
              role="button" data-bs-toggle="dropdown" data-bs-auto-close="outside">
              <i class="bi bi-list fs-4 text-primary-pmg"></i> Menu
            </a>

            <div class="dropdown-menu border-0 shadow-lg rounded-4 mt-2 p-0 mega-menu-container">
              <div class="d-flex h-100 position-relative">

                <div class="menu-sidebar border-end bg-white py-3">
                  <ul class="list-unstyled mb-0">
                    <li v-for="section in filteredMenuStructure" :key="section.id"
                      @mouseenter="activeSection = section.id"
                      class="menu-section-item position-relative py-2 px-4 cursor-pointer"
                      :class="{ 'active': activeSection === section.id }">
                      <span class="fw-bold fs-7"
                        :class="activeSection === section.id ? 'text-primary-pmg' : 'text-dark'">
                        {{ section.title }}
                      </span>
                    </li>
                  </ul>
                  <hr class="mx-3 my-3 text-muted">
                  <div class="px-4">
                    <router-link to="setting"
                      class="d-block text-muted text-decoration-none small hover-text-primary mb-2">Configurações</router-link>
                    <!-- <a href="#" class="d-block text-muted text-decoration-none small hover-text-primary">Suporte /
                      Ajuda</a> -->
                  </div>
                </div>

                <div class="menu-content flex-grow-1 bg-white p-4">
                  <h6 class="text-uppercase text-muted fw-bold small mb-4 tracking-wide">
                    {{ currentMenuData.title }}
                  </h6>
                  <div class="row g-4">
                    <div class="col-6" v-for="item in currentMenuData.items" :key="item.label">
                      <router-link :to="item.route"
                        class="text-decoration-none text-dark d-flex align-items-center menu-link hover-text-primary">
                        <i :class="item.icon" class="me-2 fs-5 text-muted icon-transition"></i>
                        <span class="fw-medium fs-7">{{ item.label }}</span>
                      </router-link>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </li>
        </ul>

        <div class="d-lg-none mt-3 pt-2">
          <span class="text-muted small fw-bold text-uppercase px-2 tracking-wide">Navegação Principal</span>

          <div class="accordion accordion-flush mt-2" id="accordionMobileMenu">
            <div class="accordion-item bg-transparent border-0" v-for="section in filteredMenuStructure"
              :key="section.id">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed bg-transparent fw-bold text-dark px-2 py-3 shadow-none"
                  type="button" data-bs-toggle="collapse" :data-bs-target="'#collapse' + section.id">
                  {{ section.title }}
                </button>
              </h2>
              <div :id="'collapse' + section.id" class="accordion-collapse collapse"
                data-bs-parent="#accordionMobileMenu">
                <div class="accordion-body p-0 pb-2">
                  <div class="list-group list-group-flush">
                    <router-link :to="item.route" v-for="item in section.items" :key="item.label"
                      class="list-group-item list-group-item-action bg-transparent border-0 d-flex align-items-center py-2 px-4 text-muted">
                      <i :class="item.icon" class="me-3 fs-5"></i>
                      <span class="fs-7 fw-medium">{{ item.label }}</span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr class="text-muted my-2">
          <div class="px-2 py-2">
            <router-link to="setting" class="d-flex align-items-center text-muted text-decoration-none py-2 mb-1">
              <i class="bi bi-gear me-3 fs-5"></i> <span class="fs-7 fw-medium">Configurações</span>
            </router-link>
            <a href="#" class="d-flex align-items-center text-muted text-decoration-none py-2">
              <i class="bi bi-question-circle me-3 fs-5"></i> <span class="fs-7 fw-medium">Suporte / Ajuda</span>
            </a>
          </div>
        </div>

        <ul
          class="navbar-nav ms-auto mb-2 mb-lg-0 align-items-start align-items-lg-center gap-2 border-top border-lg-0 pt-3 pt-lg-0 mt-2 mt-lg-0">
          <li class="nav-item dropdown d-none d-lg-block me-2">
            <button class="btn btn-pmg-action dropdown-toggle shadow-sm d-flex align-items-center" type="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              Ações Rápidas
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow-lg border-0 mt-2 rounded-4 p-2">
              <li><a class="dropdown-item rounded-3 fw-medium py-2" href="#" @click="openModalTransaction('create')"><i
                    class="bi bi-cash-coin me-2 text-success"></i> Nova Transação</a></li>
              <li><a class="dropdown-item rounded-3 fw-medium py-2" href="#" @click="openModalClient('create')"><i
                    class="bi bi-person-plus me-2 text-primary"></i> Novo Cliente</a></li>
            </ul>
          </li>

          <li class="nav-item dropdown notification-dropdown pe-lg-3 border-end-lg d-none d-lg-block">
            <a class="nav-link position-relative p-2 rounded-circle hover-bg-light" href="#" role="button"
              data-bs-toggle="dropdown">
              <i class="bi bi-bell text-muted fs-5"></i>
              <span v-if="unreadNotifications > 0"
                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger p-1">
                {{ unreadNotifications }}
              </span>
            </a>
            <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-4 mt-3 notification-list p-0">
              <li class="p-3 border-bottom d-flex justify-content-between align-items-center bg-light rounded-top-4">
                <h6 class="fw-bold m-0 text-dark">Notificações</h6>
              </li>

              <li v-if="!notifications || notifications.length === 0" class="p-4 text-center text-muted">
                <i class="bi bi-bell-slash fs-3 mb-2 d-block opacity-50"></i>
                <span class="fs-7 fw-medium d-block">Nenhuma notificação por aqui</span>
              </li>

              <li v-else v-for="note in notifications" :key="note.id" class="notification-item p-3 border-bottom"
                :class="{ 'unread': !note.read }">
                <div class="d-flex gap-3 align-items-start">
                  <div class="icon-circle" :class="'bg-' + note.type + '-subtle text-' + note.type">
                    <i :class="note.icon"></i>
                  </div>
                  <div class="flex-grow-1">
                    <p class="mb-0 text-dark fw-medium fs-7">{{ note.title }}</p>
                    <small class="text-muted d-block fs-8">{{ note.message }}</small>
                  </div>
                  <div v-if="!note.read" class="unread-dot mt-2"></div>
                </div>
              </li>

              <li class="text-center p-2 rounded-bottom-4 bg-white">
                <a href="#" class="text-primary small fw-medium text-decoration-none d-block">Ver todas</a>
              </li>
            </ul>
          </li>

          <li class="nav-item d-lg-none w-100 px-2 py-2">
            <a href="#" class="text-muted text-decoration-none d-flex align-items-center">
              <i class="bi bi-bell me-3 fs-5"></i>
              <span class="fs-7 fw-medium flex-grow-1">Notificações</span>
              <span v-if="unreadNotifications > 0" class="badge rounded-pill bg-danger">{{ unreadNotifications }}</span>
            </a>
          </li>

          <li class="nav-item dropdown w-100 w-lg-auto ms-lg-2 mt-2 mt-lg-0">
            <a class="user-profile-toggle d-flex align-items-center gap-3 text-decoration-none dropdown-toggle p-2 p-lg-0 rounded hover-bg-light"
              href="#" role="button" data-bs-toggle="dropdown">
              <div
                class="avatar-nav-gen d-flex align-items-center justify-content-center fw-bold text-white bg-primary-pmg m-0">
                {{ userInitials }}
              </div>
              <div class="d-block text-start">
                <p class="user-name mb-0">{{ userName }}</p>
              </div>
            </a>
            <ul class="dropdown-menu dropdown-menu-end border-0 shadow-lg rounded-3 mt-3 profile-dropdown-mobile">
              <!-- <li><a class="dropdown-item py-2" href="#"><i class="bi bi-person me-2"></i> Editar Perfil</a></li>
              <li><a class="dropdown-item py-2" href="#"><i class="bi bi-gear me-2"></i> Configurações</a></li>
              <li>
                <hr class="dropdown-divider">
              </li> -->
              <li>
                <a class="dropdown-item py-2 text-danger cursor-pointer" @click.prevent="handleLogout">
                  <i class="bi bi-box-arrow-right me-2"></i> Sair do Sistema
                </a>
              </li>
            </ul>
          </li>

        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import api from '@/services/api';
import LogoSystem from '@/LogoSystem.vue';
import { transactionModalState } from '@/utils/transactionModalState';
import { clientModalState } from '@/utils/clientModalState';
import TransactionModal from '@/components/financial/TransactionModal.vue'
import ClientModal from '@/components/client/ClientModal.vue'

export default {
  name: 'AppNavbar',
  components: { LogoSystem, TransactionModal, ClientModal },
  data() {
    return {
      alerts: [],
      userName: 'Usuário',
      activeSection: 'cadastros',
      allowedFeatures: [],
      menuStructure: [
        {
          id: 'cadastros_auxiliares',
          title: 'Cadastros Auxiliares',
          items: [
            { label: 'Categorias', icon: 'bi-tags', route: '/category', feature: 'cadastros-auxiliares.categorias' },
            { label: 'Filiais', icon: 'bi-building', route: '/branch', feature: 'cadastros-auxiliares.filiais' },
            { label: 'Centro de Custos', icon: 'bi-diagram-3-fill', route: '/cost', feature: 'cadastros-auxiliares.centro-custos' },
          ]
        },
        {
          id: 'produtos_servicos',
          title: 'Produtos e Serviços',
          items: [
            { label: 'Produtos', icon: 'bi-box-seam', route: '/product', feature: 'produtos-servicos.produtos' },
            { label: 'Serviços', icon: 'bi-tools', route: '/service', feature: 'produtos-servicos.servicos-catalogo' },
            { label: 'Inventário', icon: 'bi-clipboard-data', route: '/inventory', feature: 'produtos-servicos.inventario' },
          ]
        },
        {
          id: 'clientes_fornecedores',
          title: 'Clientes e Fornecedores',
          items: [
            { label: 'Clientes', icon: 'bi-people', route: '/client', feature: 'clientes-fornecedores.clientes' },
            { label: 'Fornecedores', icon: 'bi-truck', route: '/supplier', feature: 'clientes-fornecedores.fornecedores' },
          ]
        },
        {
          id: 'transacoes',
          title: 'Transações',
          items: [
            { label: 'Orçamento', icon: 'bi-file-earmark-text', route: '/quote', feature: 'transacoes.orcamento' },
            { label: 'Financeiro', icon: 'bi-cash-coin', route: '/financial', feature: 'transacoes.financeiro' },
          ]
        },
        {
          id: 'bi_indicadores',
          title: 'BI e Indicadores',
          items: [
            { label: 'Dashboard', icon: 'bi-bullseye', route: '/financial-dashboard', feature: 'bi-indicadores.dashboard' }
          ]
        },
        {
          id: 'gestao_relacionamento',
          title: 'Gestão de Relacionamento',
          items: [
            { label: 'Leads', icon: 'bi-funnel-fill', route: '/list-page-lead', feature: 'gestao-relacionamento.leads' },
            { label: 'CRM', icon: 'bi-headset', route: '/crm', feature: 'gestao-relacionamento.crm' },
            { label: 'Whatsapp', icon: 'bi-whatsapp', route: '/whatsapp', feature: 'gestao-relacionamento.whatsapp' },
            { label: 'E-mails', icon: 'bi-mailbox', route: '/template-email', feature: 'gestao-relacionamento.emails' },
            { label: 'Landing Pages', icon: 'bi-layout-text-window-reverse', route: '/list-landing-page', feature: 'gestao-relacionamento.pages' },
          ]
        },
        {
          id: 'eventos',
          title: 'Eventos',
          items: [
            { label: 'Calendário', icon: 'bi-calendar', route: '/event', feature: 'eventos.calendario' }
          ]
        },
        {
          id: 'usuarios',
          title: 'Usuários',
          items: [
            { label: 'Perfis de Acesso', icon: 'bi-shield-check', route: '/role', feature: 'usuarios.perfis-acesso' },
            { label: 'Usuários', icon: 'bi-person-gear', route: '/user', feature: 'usuarios.acessos' }
          ]
        },
      ],
      notifications: []
    }
  },
  async mounted() {
    const savedName = localStorage.getItem('name');
    if (savedName) {
      this.userName = savedName;
    }
    await this.fetchSystemPermissions();
  },
  computed: {
    filteredMenuStructure() {
      if (!this.allowedFeatures || this.allowedFeatures.length === 0) return [];

      return this.menuStructure.map(section => {
        const allowedItems = section.items.filter(item =>
          !item.feature || this.allowedFeatures.includes(item.feature)
        );
        return { ...section, items: allowedItems };
      }).filter(section => section.items.length > 0);
    },
    currentMenuData() {
      return this.filteredMenuStructure.find(s => s.id === this.activeSection) || this.filteredMenuStructure[0] || { items: [] };
    },
    unreadNotifications() {
      return this.notifications.filter(n => !n.read).length;
    },
    userInitials() {
      if (!this.userName || this.userName === 'Usuário') return 'US';
      const names = this.userName.trim().split(' ');
      if (names.length >= 2) {
        return (names[0][0] + names[names.length - 1][0]).toUpperCase();
      }
      return this.userName.substring(0, 2).toUpperCase();
    }
  },
  watch: {
    $route() {
      const navbar = document.getElementById('mainNavbar');
      const toggler = document.querySelector('.navbar-toggler');
      if (navbar && navbar.classList.contains('show') && toggler) {
        toggler.click();
      }

      if (document.activeElement) {
        document.activeElement.blur();
      }
      document.body.click();
    }
  },
  methods: {
    async fetchSystemPermissions() {
      try {
        const response = await api.get('/system/permissions');
        this.allowedFeatures = response.data.permissions || [];
      } catch (error) {
        console.error("Erro ao buscar permissões do sistema", error);
      }
    },
    async handleLogout() {
      transactionModalState.close();
      clientModalState.close();
      await new Promise(resolve => setTimeout(resolve, 50));
      try {
        await api.post('/logout');
      } catch (error) {
        console.warn("Erro ao deslogar", error);
      } finally {
        localStorage.removeItem('access_token');
        window.location.href = window.location.origin + '/login?loggedOut=true';
      }
    },
    openModalTransaction(item = null) {
      transactionModalState.open(item, () => {
        this.showAlert('Lançamento salvo com sucesso!');
      });
    },
    openModalClient(item = null) {
      clientModalState.open(item, () => {
        this.showAlert('Salvo com sucesso!');
      });
    },
    showAlert(message, type = 'success') {
      const id = Date.now();
      const themeClass = type === 'error' ? 'danger' : type;
      let icon = 'bi-check-circle-fill';
      if (themeClass === 'danger') icon = 'bi-x-circle-fill';
      if (type === 'warning') icon = 'bi-exclamation-triangle-fill';
      this.alerts.push({ id, message, type: themeClass, icon });
      setTimeout(() => this.removeAlert(id), themeClass === 'danger' ? 6000 : 4000);
    },
    removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },
  }
}
</script>

<style scoped>
.text-primary-pmg {
  color: #561569;
}

.bg-primary-pmg {
  background-color: #561569;
}

.cursor-pointer {
  cursor: pointer;
}

.hover-bg-light:hover {
  background-color: #F3F4F6;
}

.hover-text-primary:hover {
  color: #561569 !important;
}

.navbar-pmg {
  border-bottom: 1px solid #E5E7EB;
  padding: 0.5rem 0;
}

.mega-menu-container {
  width: 620px;
  min-height: 320px;
  overflow: visible;
}

.menu-sidebar {
  width: 250px;
  flex-shrink: 0;
  border-radius: 1rem 0 0 1rem;
}

.menu-content {
  border-radius: 0 1rem 1rem 0;
}

.menu-section-item {
  transition: all 0.2s ease;
}

.menu-section-item.active {
  background-color: #f8f9fa;
  border-left: 4px solid #561569;
}

.menu-section-item.active::after {
  content: '';
  position: absolute;
  right: -1px;
  top: 50%;
  transform: translateY(-50%);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid #f8f9fa;
  z-index: 2;
}

.tracking-wide {
  letter-spacing: 1px;
}

.menu-link {
  transition: all 0.2s;
}

.icon-transition {
  transition: color 0.2s;
}

.menu-link:hover .icon-transition {
  color: #561569 !important;
}

.avatar-nav-gen {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 0.85rem;
}

.user-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #111827;
}

.user-role {
  font-size: 0.7rem;
}

.fs-7 {
  font-size: 0.95rem;
}

.fs-8 {
  font-size: 0.8rem;
}

.notification-item.unread {
  background-color: #f0f7ff;
}

.icon-circle {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-success-subtle {
  background-color: #ecfdf5;
  color: #059669;
}

.bg-danger-subtle {
  background-color: #fef2f2;
  color: #dc2626;
}

@media (min-width: 992px) {
  .border-lg-0 {
    border-top: none !important;
  }
}

@media (max-width: 991px) {

  .border-end-lg {
    border-right: none !important;
  }

  .accordion-button:focus {
    box-shadow: none !important;
    background-color: transparent !important;
  }

  .accordion-button:not(.collapsed) {
    color: #561569;
    background-color: transparent !important;
    box-shadow: none !important;
  }

  .profile-dropdown-mobile {
    position: static !important;
    float: none;
    box-shadow: none !important;
    background-color: #f8f9fa !important;
    border-radius: 12px;
    margin-top: 0.5rem;
    padding: 0.5rem;
  }
}

.router-link-exact-active span,
.router-link-exact-active i {
  color: #561569 !important;
  font-weight: 700 !important;
}

.notification-list {
  min-width: 320px !important;
  max-width: 380px;
  border-radius: 16px !important;
  padding: 0;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
}

.notification-item {
  padding: 12px 16px !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 12px;
  transition: background 0.2s;
}

.notification-list li:last-child a {
  border-top: 1px solid #f1f1f1;
  padding: 10px;
  background-color: #ffffff;
  border-radius: 0 0 16px 16px;
}

.btn-pmg-action {
  background-color: #561569;
  /* Azul Marinho Profundo */
  color: #ffffff;
  border: none;
  border-radius: 12px;
  /* Bordas bem arredondadas como na sua imagem */
  padding: 10px 20px;
  font-weight: 600;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.btn-pmg-action:hover {
  background-color: #3f0f4e;
  /* Um tom levemente mais escuro ao passar o mouse */
  color: #ffffff;
  transform: translateY(-1px);
}

.btn-pmg-action:active {
  transform: translateY(0);
}

@media (max-width: 991px) {
  .notification-list {
    min-width: 100% !important;
    box-shadow: none !important;
    background-color: #f8f9fa !important;
  }
}
</style>